// controllers/toast_controller.js
import { Controller } from "@hotwired/stimulus";

export default class ToastController extends Controller {
  static values = {
    timeout:        { type: Number, default: 5000 }, // auto-hide
    redirectUrl:    String,                           // optional
    redirectDelay:  { type: Number, default: 1200 },  // wait before redirect
    redirectAction: { type: String, default: "replace" } // Turbo action: "advance" | "replace"
  };

  connect() {
    // Auto-dismiss timer
    if (this.timeoutValue > 0) {
      this.hideTimer = setTimeout(() => this.close(), this.timeoutValue);
    }

    // Optional redirect timer
    if (this.hasRedirectUrlValue) {
      this.redirectTimer = setTimeout(() => this.performRedirect(), this.redirectDelayValue);
    }
  }

  disconnect() {
    clearTimeout(this.hideTimer);
    clearTimeout(this.redirectTimer);
  }

  close() {
    this.element.remove();
  }

  performRedirect() {
    // Hide immediately for a snappier feel
    this.close();
    const url = this.redirectUrlValue;
    if (!url) return;

    if (window.Turbo?.visit) {
      Turbo.visit(url, { action: this.redirectActionValue });
    } else {
      if (this.redirectActionValue === "replace") {
        window.location.replace(url);
      } else {
        window.location.assign(url);
      }
    }
  }
}
